export default [
  {
    name: 'thread',
    label: 'Deals',
    permissions: [{
      subject: 'thread',
      actions: ['view-nav-link']
    }],
    submenu: [
      {
        name: 'all-deals',
        icon: 'local_offer',
        label: 'All deals',
        paths: ['/threads'],
        permissions: [{
          subject: 'thread',
          actions: ['view']
        }],
      },
      {
        name: 'scheduled-threads',
        icon: 'dvr',
        label: 'Scheduled threads',
        paths: ['/scheduled-threads'],
        permissions: [{
          subject: 'schedule-thread',
          actions: ['list-all']
        }],
      },
      {
        name: 'pins',
        icon: 'push_pin',
        label: 'Pins',
        paths: ['/pins'],
        permissions: [{
          subject: 'pin',
          actions: ['list-all']
        }],
      },
    ]
  },
  {
    name: 'promotions',
    label: 'Promotions',
    permissions: [{
      subject: 'ad-manager.order',
      actions: ['view-nav-link']
    }],
    submenu: [
      {
        name: 'all-promotions',
        icon: 'trending_up',
        label: 'All promotions',
        paths: ['/promotions', '/promotions-archived'],
        permissions: [{
          subject: 'ad-manager.order',
          actions: ['view-nav-link']
        }],
        isExact: true,
      },
      {
        name: 'sponsorships',
        icon: 'bolt',
        label: 'Logo Sponsorship',
        paths: ['/sponsorships'],
        permissions: [{
          subject: 'sponsorship',
          actions: ['list-all']
        }],
      },
      {
        name: 'promotions-deals',
        icon: 'local_offer',
        label: 'Promotable deals',
        paths: ['/promotable-deals'],
        permissions: [{
          subject: 'ad-manager.order',
          actions: ['view-business-contact']
        }],
        isExact: true
      }
    ]
  },
  {
    name: 'events',
    label: 'Events',
    permissions: [{
      subject: 'event.assets',
      actions: ['list-all']
    }],
    submenu: [
      {
        name: 'events',
        icon: 'date_range',
        label: 'Event promotion',
        paths: ['/events/promotion'],
        permissions: [{
          subject: 'event.promotions',
          actions: ['list-all']
        }],
      },
      {
        name: 'event-assets',
        icon: 'image',
        label: 'Event assets',
        paths: ['/events/assets'],
        permissions: [{
          subject: 'event.assets',
          actions: ['list-all']
        }],
    },
    ],
  },
  {
    name: 'reports',
    label: 'Analytics',
    permissions: [{
      subject: 'reports-tab',
      actions: ['view']
    }],
    submenu: [
      {
        name: 'performance-reports',
        icon: 'analytics',
        label: 'Reports',
        paths: ['/reports'],
        permissions: [{
          subject: 'performance-reports',
          actions: ['list-all']
        }],
        isExact: true
      },
      {
        name: 'daily-reports',
        icon: 'mouse',
        label: 'CPC Reports',
        paths: ['/reports/daily', '/reports/daily/advanced'],
        permissions: [{
          subject: 'cpc-reports',
          actions: ['view']
        }],
        isExact: true
      },
      {
        name: 'daily-reports-cpm',
        icon: 'remove_red_eye',
        label: 'CPM Reports',
        paths: ['/reports/daily-cpm'],
        permissions: [{
          subject: 'cpm-reports',
          actions: ['view']
        }],
        isExact: true
      }
    ]
  },
  {
    name: 'business',
    label: 'Business',
    permissions: [],
    submenu: [
      {
        name: 'accounts',
        icon: 'domain',
        label: 'Accounts',
        paths: ['/users'],
        permissions: [
          {
            subject: 'user',
            actions: ['view-nav-link']
          }
        ],
        submenu: [
          {
            name: 'business',
            icon: 'business_center',
            label: 'Businesses',
            paths: ['/businesses'],
            permissions: [{
              subject: 'business',
              actions: ['view-nav-link', 'list-all']
            }],
          },
          {
            name: 'user',
            icon: 'supervisor_account',
            label: 'Users',
            paths: ['/users/pending', '/users'],
            permissions: [
              {
                subject: 'user',
                actions: ['view-nav-link']
              }
            ],
          },
        ],
      },
      {
        name: 'billing',
        icon: 'receipt_long',
        label: 'Billing',
        permissions: [],
        submenu: [
          {
            name: 'payment',
            icon: 'payment',
            label: 'Payments',
            paths: ['/payments'],
            permissions: [{
              subject: 'payment',
              actions: ['list-all']
            }],
          },
          {
            name: 'invoice',
            icon: 'event',
            label: 'Invoices',
            paths: ['/invoices'],
            permissions: [{
              subject: 'invoice',
              actions: ['list-all']
            }]
          },
          {
            name: 'billing-accounts',
            icon: 'credit_card',
            label: 'Accounts',
            paths: ['/billing', '/network-review'],
            permissions: [{
              subject: 'billing',
              actions: ['list-all']
            }],
          },
        ],
      },
      {
        name: 'billing-reports',
        icon: 'credit_card',
        label: 'Billings',
        paths: ['/reports/monthly'],
        permissions: [{
          subject: 'billing-reports',
          actions: ['view']
        }],
      },
      {
        name: 'business-users',
        icon: 'supervisor_account',
        label: 'Members',
        paths: ['/business-users'],
        permissions: [{
          subject: 'user',
          actions: ['view-nav-link-business']
        }],
      },
      {
        name: 'contract',
        icon: 'request_quote',
        label: 'Price contracts',
        paths: ['/contracts'],
        permissions: [{
          subject: 'contract',
          actions: ['list-all']
        }],
      },
    ]
  },
  {
    name: 'creator_program',
    label: 'Creator program',
    permissions: [],
    submenu: [
      {
        name: 'creator-program-businesses',
        icon: 'leaderboard',
        label: 'Creators businesses',
        paths: ['/creator-program/businesses'],
        permissions: [
          {
            subject: 'loyalty_program',
            actions: ['list-all'],
          },
        ],
      },
      {
        name: 'creator-program-billing',
        icon: 'account_balance_wallet',
        label: 'Billing accounts',
        paths: ['/creator-program/billing-accounts'],
        permissions: [
          {
            subject: 'loyalty_program',
            actions: ['list-all'],
          },
        ],
      },
    ]
  },
  {
    name: 'administration',
    label: 'Administration',
    permissions: [],
    submenu: [
      {
        name: 'canned-replies',
        icon: 'chat',
        label: 'Canned replies',
        paths: ['/canned-replies'],
        permissions: [{
          subject: 'comment',
          actions: ['list-all']
        }],
      },
      {
        name: 'label',
        icon: 'label',
        label: 'Labels',
        paths: ['/labels'],
        permissions: [{
          subject: 'label',
          actions: ['view']
        }],
      },
      {
        name: 'internal_users',
        icon: 'badge',
        label: 'Internal users',
        paths: ['/internal-users'],
        permissions: [{
          subject: 'banner',
          actions: ['view']
        }],
      },
      {
        name: 'site-messages',
        icon: 'picture_in_picture',
        label: 'Site messages',
        paths: ['/site-messages'],
        permissions: [{
          subject: 'banner',
          actions: ['view']
        }],
      },
      {
        name: 'package',
        icon: 'collections_bookmark',
        label: 'Packages',
        paths: ['/packages'],
        permissions: [{
          subject: 'package',
          actions: ['view']
        }],
      },
    ]
  },  
];
